<div class="main-div">
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>Verificador de autenticidade do documento</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <form [formGroup]="validationForm" (ngSubmit)="onSubmit()">
        <div>
          <mat-form-field>
            <mat-label>CÃ³digo verificador</mat-label>
            <input matInput formControlName="code" type="text" appCodeMask>
            @if (validationForm.get('code')?.hasError('required')) {
              <mat-error>Campo obrigatÃ³rio.</mat-error>
            }
          </mat-form-field>
        </div>
        <button mat-raised-button color="primary" type="submit" [disabled]="!validationForm.valid">
          <mat-icon>fingerprint</mat-icon>
          Verificar
        </button>
      </form>
    </mat-card-content>
    <mat-card-content class="spacer">
      @if(validationData){
        <div>
          <mat-divider></mat-divider>
          <p><strong>{{ validationData.message }}</strong></p>
          <p><strong>Nome do usuÃ¡rio:</strong> {{ validationData.userName }}</p>
          <p><strong>Curso:</strong> {{ validationData.curseName }}</p>
          <p><strong>Data do documento:</strong> {{ validationData.documentDateFormatted }}</p>
        </div>
      }
      @if(errorMessage){
        <div class="error-message">
          <mat-error>{{ errorMessage }}</mat-error>
        </div>
      }
    </mat-card-content>
  </mat-card>
</div>
